import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    ordersList: {
      data: [],
      status: statuses.EMPTY,
    },
    ordersListFilters: {
      data: [],
      status: statuses.EMPTY,
    },
    ordersClassifiers: {
      data: [],
      status: statuses.EMPTY,
    },
    orderUpdateData: {
      data: [],
      status: statuses.EMPTY,
    },
    orderUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    orderCreate: {
      data: [],
      status: statuses.EMPTY,
    },
    orderApproval: {
      data: [],
      status: statuses.EMPTY,
    },
    orderDelete: {
      data: [],
      status: statuses.EMPTY,
    },
    orderCopy: {
      data: [],
      status: statuses.EMPTY,
    },
    orderAttachments: {
      data: [],
      status: statuses.EMPTY,
    },
    orderUpdateAttachmentsStatus: {
      data: [],
      status: statuses.EMPTY,
    },
    orderAddCommentToAttachment: {
      data: [],
      status: statuses.EMPTY,
    },
    orderDeleteAttachment: {
      data: [],
      status: statuses.EMPTY,
    },
    orderActivity: {
      data: [],
      status: statuses.EMPTY,
    },
    orderCreateItem: {
      data: [],
      status: statuses.EMPTY,
    },
    orderItems: {
      data: [],
      status: statuses.EMPTY,
    },
    orderUpdateItem: {
      data: [],
      status: statuses.EMPTY,
    },
    orderDeleteItem: {
      data: [],
      status: statuses.EMPTY,
    },
    orderFactsAndInvoicesList: {
      data: [],
      status: statuses.EMPTY,
    },
    orderUpdateFact: {
      data: [],
      status: statuses.EMPTY,
    },
    orderApproveFactAndInvoice: {
      data: [],
      status: statuses.EMPTY,
    },
    orderItemsSendInvoiceToBookkeeper: {
      data: [],
      status: statuses.EMPTY,
    },
    orderItemsApproveInvoiceReview: {
      data: [],
      status: statuses.EMPTY,
    },
    orderItemsDeclineInvoiceReview: {
      data: [],
      status: statuses.EMPTY,
    },
    orderInvoicesAdvanceList: {
      data: [],
      status: statuses.EMPTY,
    },
    orderApproveInvoiceAdvance: {
      data: [],
      status: statuses.EMPTY,
    },
    orderRemoveInvoiceAdvance: {
      data: [],
      status: statuses.EMPTY,
    },
    orderApproveInvoiceAdvanceReview: {
      data: [],
      status: statuses.EMPTY,
    },
    orderDeclineInvoiceAdvanceReview: {
      data: [],
      status: statuses.EMPTY,
    },
    orderSendInvoiceAdvanceToBookkeeper: {
      data: [],
      status: statuses.EMPTY,
    },
  };
};

const Orders = {
  namespaced: true,
  state: defaultState,
  getters: {
    ordersList: (state) => state.ordersList,
    ordersListFilters: (state) => state.ordersListFilters,
    ordersClassifiers: (state) => state.ordersClassifiers,
    orderUpdateData: (state) => state.orderUpdateData,
    orderUpdate: (state) => state.orderUpdate,
    orderCreate: (state) => state.orderCreate,
    orderApproval: (state) => state.orderApproval,
    orderDelete: (state) => state.orderDelete,
    orderCopy: (state) => state.orderCopy,
    orderAttachments: (state) => state.orderAttachments,
    orderUpdateAttachmentsStatus: (state) => state.orderUpdateAttachmentsStatus,
    orderAddCommentToAttachment: (state) => state.orderAddCommentToAttachment,
    orderDeleteAttachment: (state) => state.orderDeleteAttachment,
    orderActivity: (state) => state.orderActivity,
    orderItems: (state) => state.orderItems,
    orderCreateItem: (state) => state.orderCreateItem,
    orderUpdateItem: (state) => state.orderUpdateItem,
    orderDeleteItem: (state) => state.orderDeleteItem,
    orderFactsAndInvoicesList: (state) => state.orderFactsAndInvoicesList,
    orderUpdateFact: (state) => state.orderUpdateFact,
    orderApproveFactAndInvoice: (state) => state.orderApproveFactAndInvoice,
    orderItemsSendInvoiceToBookkeeper: (state) => state.orderItemsSendInvoiceToBookkeeper,
    orderItemsApproveInvoiceReview: (state) => state.orderItemsApproveInvoiceReview,
    orderItemsDeclineInvoiceReview: (state) => state.orderItemsDeclineInvoiceReview,
    orderInvoicesAdvanceList: (state) => state.orderInvoicesAdvanceList,
    orderApproveInvoiceAdvance: (state) => state.orderApproveInvoiceAdvance,
    orderRemoveInvoiceAdvance: (state) => state.orderRemoveInvoiceAdvance,
    orderApproveInvoiceAdvanceReview: (state) => state.orderApproveInvoiceAdvanceReview,
    orderDeclineInvoiceAdvanceReview: (state) => state.orderDeclineInvoiceAdvanceReview,
    orderSendInvoiceAdvanceToBookkeeper: (state) => state.orderSendInvoiceAdvanceToBookkeeper,
  },
  mutations,
  actions,
};

export { Orders, defaultState };
